import realpressListProperty from './archive-property/property-list';
import realpressSwitchLayout from './archive-property/switch-layout';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressListProperty();
	realpressSwitchLayout();
} );
